module.exports = __webpack_public_path__ + "img/await-icon.7ae40c9.svg";